/* eslint-disable import/no-anonymous-default-export */
export default {
  'Welcome to qMenu.': '欢迎来到qMenu',
  'Restaurant sign up in 3 minutes or less': '注册只需要3分钟',
  'Your Unique Promo Code': '您专属的促销码',
  'Identify your restaurant.': '确定您的餐馆',
  'Looks like we found it based on your promo code!':
    '我们已根据您的专属促销码找到您的餐馆！',
  'Not the right one? Click below': '找错了吗？点击以下',
  'Not my restaurant': '这不是我的餐馆',
  'Your Menu': '步骤2：您的菜单',
  'Preview Menu Demo *': '预览样本菜单',
  'For now, we’ll use a sample menu to get started. Click to open it! This is what the customer sees.':
    '您可以点击样本菜单，查看客户的点餐体验',
  'Your Info': '您的信息',
  'Owner Name': '业主姓名',
  'This number used for future login to your account and to perform a test on the next page.':
    '该号码用于以后登录您的帐户并在下一页进行测试。',
  'Simulate a Customer Order!': '模拟客户下单！',
  'Press the “Submit Order” button. You should soon get an SMS and call about this order.':
    '点击“提交测试订单”按钮。您应该很快会收到一条短信和电话通知此订单。',
  'Place Test Order': '提交测试订单',
  'Receiving Qmenu orders is that easy!': '接收Qmenu订单就这么容易！',
  'Looks like your restaurant already exists in our system. Please call support for help.':
    '看来您的餐馆已经存在于我们的系统。 请致电客服以获得帮助。',
  'Don’t worry though, Qmenu supports many types of order notifications: fax, phone, sms, email, and even a best-in-class cloud printing solution!':
    '接收Qmenu订单就这么容易！Qmenu免费支持多种类型的订单通知方式：传真，电话，短信，电子邮件，甚至一流的云打印系统！',
  'Upon submitting the test order, you will receive an SMS notification at ':
    '提交测试订单后，您将在',
  'Use a different number?': '收到SMS通知',
  Back: '上一步',
  Next: '下一步',
  'Preview Customer Experience': '预览客人体验',
  'Interested in joining QMenu? Here’s the Deal': '有兴趣加入Qmenu吗？',
  'One month free - no contract, cancel anytime, no questions asked. If you agree, please confirm below and one CSR person will help you get set up so you can start receiving orders as soon as possible!':
    '一个月免费 - 无合同，随时无理由取消。 如果您同意，请在下面确认，一位Qmenu客服将帮助您进行设置，以便您尽快开始接收订单！',
  'Finish Signup': '完成注册',
  'I Agree': '同意',
  Done: '完成',
  'Enter promo here': `请输入促销码`,
  'QMENU TEST ORDER': 'QMENU测试订单',
  'You will be notified via an SMS and call regarding this new simulated order':
    '您将收到这个模拟订单的短信和电话',
  Exit: '关闭',
  'Finish Sign Up': '完成注册',
  'Enter Promo': '请输入促销码',
  Promo: '促销',
  'Finding Your Restaurant': '寻找您的餐馆',
  Name: '名称',
  'Have Promo?': '有专属促销码？',
  Enter: '提交',
  'Enter your restaurant name and zip code.': '请输入您的餐馆名称和邮政编码',
  "Still not the right one? Call our customer support line at 404-283-9768 and they'll help you get set up!":
    '系统还是没找到您的餐馆吗？请致电Qmenu的客服热线以获得帮助！404-283-9768',
  'Looks like you already signed up with us! Please call customer support (404-382-9768) to finish account setup':
    '看来您已经使用Qmenu点餐平台！请致电Qmenu的客服热线以获得帮助。404-283-9768',
  'Thank you for your interest in QMenu. An agent will call you shortly.':
    '感谢您对QMenu的关注! 代理商会尽快给您打电话！',
  'Check your phone for a call & text from Qmenu!':
    '检查您的手机是否收到来自Qmenu的电话和短信！',
  'Not the right one? Enter your restaurant name and address.':
    '餐馆找错了吗？ 输入您的餐馆名称和地址。',
  'No restaurant associated with promo code.': '我们找不到与此促销码关联的餐馆',
  'Unable to find restaurant, please type restaurant name followed by zip code':
    '找不到餐馆，请输入餐馆名称和邮政编码',
  'Thank You!': '谢谢!',
  'Looks like we found it!': '好像找到了！',
  'Simulate Order Process': '模拟下单过程',
  'One month free, no contract': '一个月免费，无合同',
  'Cancel anytime, no questions asked': '随时取消，不问任何问题',
  'Support rep will help you get set up': 'Qmenu客服将帮助您进行设置',
  'You can start receiving orders as soon as possible':
    '您可以尽快开始接收订单',
  'Search Again': '再次搜索',
  'Enter Alternate Number': '使用其他号码？',
  'Owner Phone *': '业主手机*',
};
